import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { tap, catchError, throwError } from 'rxjs';
import {
  SHOW_SUCCESS_MESSAGE,
  SUCCESS_MESSAGE,
  SKIP_ERROR_NOTIFICATIONS,
  SKIP_NOTIFICATIONS
} from '../app/shared/tokens/http-context.tokens';
import { AuthService } from '../app/auth/services/auth.service';
import { RuntimeService } from '../app/shared/services/runtime.service';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  const authService = inject(AuthService);
  const runtimeEnvironment= inject(RuntimeService);
  let isDesktopApplication=runtimeEnvironment.IsDesktopApplication||false;
  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && req.context.get(SHOW_SUCCESS_MESSAGE) && !req.context.get(SKIP_NOTIFICATIONS)) {
        const customMessage = req.context.get(SUCCESS_MESSAGE);
        const body = event.body as any;
        const message = customMessage || (body && body.message) || 'Operation successful';
        toastr.success(message, 'Success');
      }
    }),
    catchError((error) => {
      const skipAllNotifications = req.context.get(SKIP_NOTIFICATIONS);
      const skipErrorNotifications = req.context.get(SKIP_ERROR_NOTIFICATIONS);
      console.log("detected error-->",error.status);

      console.log("isDesktopApplication==>", isDesktopApplication,' typeOf=>',typeof isDesktopApplication);
    
    //globalized error handler
     switch(error.status){
      case 403:
        isDesktopApplication ? authService.clearLicenceAndRedirect() : authService.handleUnauthorized()
        break;
      case 401:
          authService.handleUnauthorized();
          break;

      default:
        console.log("something went wrong->",error);
        break;
     }
      
      if (!skipAllNotifications && !skipErrorNotifications) {
        console.error('API Error:', error);
        const errorTitle = error.error?.message || 'Something went wrong. Please try again';
        const errorMessage = error.error?.error || 'Error';
        toastr.error(errorMessage, errorTitle);
      }
      return throwError(() => error);
    })
  );
};
